import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API_BASE } from "../apiBase";

const API = API_BASE;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);     // null = checking, false = not auth'd
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
            setUser(data);
        } catch {
            setUser(false);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { checkAuth(); }, [checkAuth]);

    const login = async (email, password) => {
        const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
        setUser(data);
        return data;
    };

    const register = async (name, email, password) => {
        const { data } = await axios.post(`${API}/api/auth/register`, { name, email, password }, { withCredentials: true });
        setUser(data);
        return data;
    };

    const logout = async () => {
        await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
